import { createSlice } from '@reduxjs/toolkit';
import { DiscountRequestModalPage } from 'view/pages/DiscountRequestList/components/DiscountRequestModal/DiscountRequestModal.constants';
import { DiscountRequestStoreType } from './discountRequest.types';

const initialState: DiscountRequestStoreType = {
  requestList: null,
  discountRequestsListParams: null,
  requestParamsForHr: null,
  modalState: { modalPage: DiscountRequestModalPage.HIDDEN, state: undefined },
};

export const discountRequestReducer = createSlice({
  name: 'discountRequest',
  initialState,
  reducers: {
    setRequestList: (state, action) => {
      state.requestList = action.payload;
    },
    setRequestListResponseParams: (state, action) => {
      state.discountRequestsListParams = action.payload;
    },
    setRequestParamsForHr: (state, action) => {
      state.requestParamsForHr = action.payload;
    },
    setDiscountRequestModalState: (state, action) => {
      state.modalState = action.payload;
    },
  },
});

export const {
  setRequestList,
  setRequestListResponseParams,
  setRequestParamsForHr,
  setDiscountRequestModalState,
} = discountRequestReducer.actions;

export default discountRequestReducer.reducer;
